module.exports = __webpack_public_path__ + "static/img/close.5e39324.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portal/close.png
// module id = CYIk
// module chunks = 32